import { gql } from 'urql';

export const LIST_CENTROS = gql`
  query ListCentros($empresaId: ID!, $search: String, $padreId: ID, $activo: Boolean) {
    listCentros(empresaId: $empresaId, search: $search, padreId: $padreId, activo: $activo) {
      id
      empresaId
      codigo
      nombre
      padreId
      activo
      hijos {
        id
        empresaId
        codigo
        nombre
        padreId
        activo
        hijos {
          id
          empresaId
          codigo
          nombre
          padreId
          activo
        }
      }
    }
  }
`;

export const CREAR_CENTRO = gql`
  mutation CrearCentro($input: CentroCostoInput!) {
    crearCentro(input: $input) {
      id
      empresaId
      codigo
      nombre
      padreId
      activo
    }
  }
`;

export const ACTUALIZAR_CENTRO = gql`
  mutation ActualizarCentro($id: ID!, $input: CentroCostoUpdateInput!) {
    actualizarCentro(id: $id, input: $input) {
      id
      empresaId
      codigo
      nombre
      padreId
      activo
    }
  }
`;

export const ACTIVAR_CENTRO = gql`
  mutation ActivarCentro($id: ID!, $activo: Boolean!) {
    activarCentro(id: $id, activo: $activo) {
      id
      activo
    }
  }
`;

